import request from '@/utils/request'

// 首页看板初始化
export function queryDashBoard(query) {
  return request({
    url: '/crmDashBoard/initPage',
    method: 'get',
    params: query
  })
}

// 工作动态列表查询
export function queryDynamicListByPage(query) {
  return request({
    url: '/workDynamic/listByPage',
    method: 'get',
    params: query
  })
}

// 查询商机趋势
export function queryBusinessTrend(query) {
  return request({
    url: '/crmDashBoard/queryBusinessTrend',
    method: 'get',
    params: query
  })
}

// 查询超期列表 
export function queryFollowOverdueList(query) {
  return request({
    url: '/crmDashBoard/queryFollowOverdueList',
    method: 'post',
    data: query
  })
}

// 查询超期天数占比
export function queryFollowOverdueRate(query) {
  return request({
    url: '/crmDashBoard/queryFollowOverdueRate',
    method: 'post',
    data: query
  })
}

// 数据简报
export function dataBriefing(query) {
  return request({
    url: '/crmDashBoard/dataBriefing',
    method: 'post',
    data: query
  })
}

// 商机漏斗 
export function businessFunnel(query) {
  return request({
    url: '/crmDashBoard/businessFunnel',
    method: 'post',
    data: query
  })
}

// 我的待办 
export function myToDoList(query) {
  return request({
    url: '/crmDashBoard/myToDoList',
    method: 'post',
    data: query
  })
}

// 业绩达成 
export function performanceAchieveInfo(query) {
  return request({
    url: '/crmDashBoard/performanceAchieveInfo',
    method: 'post',
    data: query
  })
}
